import _ from 'lodash'
import Backbone from 'backbone'
import config from 'scoreboard/components/config'
import template from './bookmark-overview-info.hbs'
import basicInfo from 'scoreboard/components/overview-info/basic-info.hbs'
import conductor from 'scoreboard/components/conductor'

/**
 * #32703 displayed when the overview button is clicked on a bookmark
 */
var BookmarkOverviewInfo = Backbone.View.extend({
	className: 'overview-info',

	events: {
		'click .go-to-origin': 'navigateToSource'
	},

	/**
	 * Displays information about a bookmark
	 *
	 * @constructs
	 *
	 * @param {Object} options
	 *
	 * @param {Bookmark} options.bookmark the bookmark
	 *
	 * @param {Object} options.spectated the item that is bookmarked
	 */
	initialize: function(options) {
		this.options = options || {}
		this.model = this.options.bookmark
		this.spectated = this.options.spectated
	},

	render: function() {
		var context = _.extend({
			source: _.get(this.spectated, 'label')
		}, this.model.attributes)

		if (!config.displayIds) {
			delete context.id
		}

		this.$el.empty().append(template(context))
		this.$('.basic-info').replaceWith(basicInfo(context))

		return this
	},

	navigateToSource: function() {
		conductor.navigateToSpectated(this.model.get('url'),
			// #35258 we want to pass the model of the bookmarked item here,
			// not the bookmark itself
			this.spectated, {forceOverview: true})
	},

	remove () {
		Backbone.View.prototype.remove.apply(this, arguments)
	}
})

export default BookmarkOverviewInfo

BookmarkOverviewInfo.__filename__ = 'components/overview-info/bookmark-overview-info.js'
